export default __webpack_public_path__ + "static/media/night-earth.c562d084.jpg";